<!--报表 历史出库单 详情-->
<template>
  <div id="orderlist">
    <el-row :data="titleData">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul class="info-list">
          <li><span>供应商</span>：<span>{{ titleData[0].SUPPLIER_NAME }}</span></li>
          <li v-if="currentOrderFlag == 1"><span>客户</span>：<span>{{ titleData[0].GYS_NAME }}</span></li>
          <li v-else><span>项目点</span>：<span>{{ titleData[0].PROJECT_NAME }}</span></li>
          <li v-if="currentOrderFlag == 1"><span>客户地址</span>：<span>{{ titleData[0].GYS_ADDRESS }}</span></li>
          <li v-else><span>项目点地址</span>：<span>{{ titleData[0].PROJECT_ADDRESS }}</span></li>
          <li><span>送货日期</span>：<span>{{ titleData[0].SEND_DAY }}</span></li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul class="info-list">
          <li><span>制单人</span>：<span>{{ managername }}</span></li>
          <li><span>档口</span>：<span>{{ titleData[0].DK_NAME }}</span></li>
          <li v-if="currentOrderFlag == 1"><span>客户电话</span>：</li>
          <li v-else><span>项目点电话</span>：<span>{{ titleData[0].PROJECT_TELPHONE }}</span></li>
          <li><span>订单编号</span>：<span>{{ titleData[0].ORDER_CODE }}</span></li>
        </ul>
      </el-col>
    </el-row>
    <el-row style="font-weight: bold">
      <el-col> 出库单详情： </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange"
          :span-method="objectSpanMethod" max-height="500">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="ORDER_PRODUCT_CODE" label="产品编码" min-width="100"></el-table-column>
          <el-table-column prop="ORDER_PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
          <el-table-column prop="ORDER_TYPE_UNIT" label="单位" min-width="50"></el-table-column>
          <el-table-column prop="ORDER_PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="ORDER_NEED_COUNT" label="实发数量"></el-table-column>
          <el-table-column prop="ORDER_REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="ORDER_REAL_TOTAL_FEE" label="实收总金额" min-width="100"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column label="出库信息">
            <el-table-column prop="DELIVER_PRODUCT_CODE" label="产品编码" min-width="100"></el-table-column>
            <el-table-column prop="DELIVER_PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="DELIVER_TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="BATCH" label="批次" min-width="100"></el-table-column>
            <el-table-column prop="PRODUCTION_DATE" label="生产日期"></el-table-column>
            <el-table-column prop="DELIVER_COUNT" label="出库数量"></el-table-column>
            <el-table-column prop="RETURN_COUNT" label="退货数量"></el-table-column>
            <el-table-column prop="DELIVER_PRICE" label="出库单价"></el-table-column>
            <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价" min-width="70"></el-table-column>
            <el-table-column prop="TAX_RATE" label="税率" min-width="45"></el-table-column>
            <el-table-column prop="DELIVER_WORTH" label="出库价值"></el-table-column>
            <el-table-column prop="REPLENISHMENT_COMMENT" label="补出库备注"></el-table-column>
          </el-table-column>
          <template></template>
          <el-table-column type="selection" width="50" fixed="right" :selectable="selectable"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <div style="float:right">
        <el-button type="default" @click="openTurnoverInfoDialog" v-if="(currentOrderFlag == 0)"
          style="margin-top: 20px">周转筐信息</el-button>
        <el-button @click="toPrintTable" style="margin-top: 20px">打印历史出库单</el-button>
        <el-button type="primary" @click="retuenWare" style="margin-top: 20px">退货</el-button>
      </div>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-if="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in stepOr.DATA" :key="item.value"></el-step>
        </el-steps>
        <h4 v-else style="color: #e6a23c">暂无流程记录信息</h4>
      </el-col>
    </el-row>
    <el-dialog title="退货信息" center :visible.sync="returnVisible" width="60%">
      <el-table :data="returnList" border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="DELIVER_PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="DELIVER_TYPE_UNIT" label="单位" width="80"></el-table-column>
        <el-table-column prop="BATCH" label="出库批次" width="80"></el-table-column>
        <el-table-column prop="DELIVER_COUNT" label="出库数量" width="80"></el-table-column>
        <el-table-column label="库位" v-if="WAREHOUSE_MODE == 2">
          <template slot-scope="scope">
            <el-select v-model="scope.row.LOCATION_CODE" clearable filterable :filter-method="positionFilter">
              <el-option v-for="item in positionList" :key="item.ID" :value="item.CODE" :label="item.CODE">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="退货数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COUNT"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="退货原因">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COMMENT"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="returnClose">取 消</el-button>
        <el-button size="small" @click="submitReturn">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 周转筐信息模态框 -->
    <el-dialog title="周转筐信息" :visible.sync="turnoverInfoVisible" center width="400px" @close="closeTurnoverInfoDialog"
      :close-on-click-modal="false">
      <el-form size="small" :model="turnoverInfoForm" ref="turnoverInfoForm">
        <el-form-item label="客户：" :label-width="labelWidth">
          <span>{{ titleData[0].CUSTOM_NAME }}</span>
        </el-form-item>
        <el-form-item label="项目点：" v-if="(currentOrderFlag == 0)" :label-width="labelWidth">
          <span>{{ titleData[0].PROJECT_NAME }}</span>
        </el-form-item>
        <div v-for="item in turnoverInfoForm.turnoverInfos" :key="item.key">
          <el-form-item label="周转筐：" :label-width="labelWidth">
            <el-select v-model="item.ID" placeholder="请选择周转筐" style="width: 100%;" filterable
              @change="turnoverChange(item)">
              <el-option v-for="item2 in turnoverList" :label="item2.NAME" :value="item2.BASKET_ID"
                :key="item2.BASKET_ID" :disabled="item2.disabled">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数量：" :label-width="labelWidth">
            <el-input v-model.number="item.COUNT" type="number" placeholder="请输入数量" :min="1" style="width: 100%;">
              <template slot="append">个</template>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button class="btn" @click="turnoverInfoForm.turnoverInfos.push({})"
            :disabled="disabledAdd">添加筐</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeTurnoverInfoDialog">取消</el-button>
        <el-button size="small" @click="submitTurnoverInfo" :disabled="disabledSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  historyOutDetailFun, returnXMDFun, queryPosition, print, historyPrintTime,
} from 'api/warehouseManager';
import http from '@/assets/common/http';
import util from '../../assets/common/util';

export default {
  data() {
    return {
      stepOr: [],
      statusFlag: 0,
      returnVisible: false,
      returnForm: {},
      managername: sessionStorage.getItem('name'),
      DELIVER_CODE: sessionStorage.getItem('ORDER_CODE'),
      tableData: [],
      titleData: [{
        SUPPLIER_NAME: '',
        PROJECT_ADDRESS: '',
        ORDER_CODE: '',
        PROJECT_NAME: '',
        SEND_DAY: '',
        PROJECT_TELPHONE: '',
        DK_NAME: '',
      }],
      formLabelWidth: '120px',
      checkedArray: [],
      returnList: [],
      spanArr: [],
      position: 0,
      currentOrderFlag: sessionStorage.getItem('currentOrderFlag'),
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      positionList: [],
      showStatus: 0,
      companyName: '',
      ALL_FEE: 0,
      isDisplay: 'none',
      turnoverInfoVisible: false,
      turnoverInfoForm: {
        turnoverInfos: [{}],
      },
      turnoverList: [],
      labelWidth: '80px',
    };
  },
  created() {
    this.companyName = sessionStorage.getItem('company');
    if (sessionStorage.getItem('tcId') == 4097) {
      this.isDisplay = 'flex';
    }
    this.getRecordDetail();
    this.queryPostionLi();
  },
  computed: {
    POSITION_CONDITION() {
      return this.$store.state.POSITION_CONDITION;
    },
    disabledAdd() {
      return this.turnoverInfoForm.turnoverInfos.length >= this.turnoverList.length;
    },
    disabledSubmit() {
      return Boolean(this.turnoverInfoForm.turnoverInfos.find((item) => !item.ID || !item.COUNT || item.COUNT < 1));
    },
  },
  methods: {
    // ----------------------退货
    returnWarehouse(row) {
      this.returnVisible = true;
      this.returnForm = row;
    },
    selectable(row, index) {
      if (row.DELIVER_COUNT == 0) {
        return false;
      }
      return true;
    },
    submitReturn() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          let tag = true;
          let flag = true;
          const reg_int = /^(?!0$)\d+$/;
          const reg_float = /^(?!0$)(\+)?\d+(\.\d+)?$/;
          const submitArr = this.returnList.map((item) => {
            if (!item.LOCATION_CODE) flag = false;
            if (util.JudgmentUnit(item.DELIVER_TYPE_UNIT)) {
              if (!reg_float.test(item.COUNT)) tag = false;
            } else {
              if (!reg_int.test(item.COUNT)) tag = false;
            }
            return {
              BATCH: item.BATCH,
              DETAIL_ID: item.ORDER_DETAIL_ID,
              PRODUCT_CODE: item.DELIVER_PRODUCT_CODE,
              PRODUCT_COUNT: item.COUNT,
              RETURN_REASON: item.COMMENT ? item.COMMENT : '',
              LOCATION_CODE: item.LOCATION_CODE,
            };
          });
          if (!tag) {
            this.$message.show({ text: '请输入正确的退货数量', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (this.WAREHOUSE_MODE == 2 && !flag) {
            this.$message.show({ text: '请输入编号选择库位', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
            DETAILS: submitArr,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            RECORD_ID: Number(sessionStorage.getItem('DELIVER_ID')),
            WAREHOUSE_MODE: this.WAREHOUSE_MODE,
          };
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          returnXMDFun(params).then((result) => {
            this.$message.show({ text: '操作成功', type: 'success' });
            this.returnVisible = false;
            this.getRecordDetail();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    returnClose() {
      this.returnVisible = false;
    },
    // ----------------------拉取数据
    getRecordDetail() {
      const params = {
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
        DELIVER_ID: Number(sessionStorage.getItem('DELIVER_ID')),
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      historyOutDetailFun(params).then((result) => {
        this.tableData = [];
        if (result.length !== 0) {
          this.tableData = result[0].DETAIL.map((item) => ({ ...item, BEFORE_TAX_PRICE: item.BEFORE_TAX_PRICE ? Number(item.BEFORE_TAX_PRICE).toFixed(2) : '' }));
          this.showStatus = result[0].ORDER_TITLE[0].TC_STATUS;
          this.rowspan(this.tableData);
          this.titleData = result[0].ORDER_TITLE;
          this.stepOr = result[0].OR[0];
          this.statusFlag = result.length > 0 ? result[0].OR[0].RN : 0;
          this.getFEE();
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getFEE() {
      let sum = 0;
      this.tableData.forEach((item, index) => {
        sum += Number(item.DELIVER_PRICE) * Number(item.DELIVER_COUNT);
      });
      this.ALL_FEE = sum.toFixed(2);
    },
    // 选择需要退货的商品
    handleSelectionChange(val) {
      this.checkedArray = val;
    },
    retuenWare() {
      if (this.checkedArray.length !== 0) {
        this.returnList = this.checkedArray;
        this.returnVisible = true;
        this.positionFilter();
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    queryPostionLi() {
      if (this.POSITION_CONDITION.POSITIONLIST != null) {
        this.positionListAll = this.POSITION_CONDITION.POSITIONLIST;
        return;
      }
      queryPosition({ STATUS: 1 }).then((result) => {
        this.positionListAll = Object.freeze(result);
        // 将库位信息存储到vuex中
        this.$store.dispatch('SET_POSITION_CONDITION', {
          POSITIONLIST: result,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    positionFilter(query = '') {
      const arr = this.positionListAll.filter((item) => item.CODE.includes(query));
      if (arr.length > 50) {
        this.positionList = arr.slice(0, 50);
      } else {
        this.positionList = arr;
      }
    },
    // --------------------------行
    rowspan() {
      this.spanArr = [];
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.tableData[index].ORDER_DETAIL_ID === this.tableData[index - 1].ORDER_DETAIL_ID) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    // ---------------------------------表格合并行
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 7 || columnIndex === 8) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main">';
      html += `<div class="title">${this.companyName}历史出库单</div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">供应商：${this.titleData[0].SUPPLIER_NAME}</div><div style="font-size: 20px;">送货日期：${this.titleData[0].SEND_DAY}</div></div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">订单编号：${this.titleData[0].ORDER_CODE}</div><div class="code" style="font-size: 20px;">制单人：${this.managername}</div></div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">${this.currentOrderFlag == 1 ? `客户：${this.titleData[0].GYS_NAME}` : `项目点：${this.titleData[0].PROJECT_NAME}`}</div><div class="code" style="font-size: 20px;">档口：${this.titleData[0].DK_NAME}</div></div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">${this.currentOrderFlag == 1 ? `客户地址：${this.titleData[0].GYS_ADDRESS}` : `项目点地址：${this.titleData[0].PROJECT_ADDRESS}`}</div><div class="code" style="font-size: 20px;">${this.currentOrderFlag == 1 ? '客户电话：' : `项目点电话：${this.titleData[0].PROJECT_TELPHONE}`}</div></div>`;
      html += '<table border="1" cellspacing="0" style="position:relative; width:98%;"><div class="el-table__body el-table__header">';
      html += '<tr><th style="width: 50px">序号</th> <th>名称</th> <th>单位</th> <th  style="width: 40px">产品编号</th> <th style="width: 70px">出库单价</th> <th  style="width: 70px">出库数量</th> <th>出库金额</th> </tr>';
      html += '</div><div class="el-table__body">';
      this.tableData.forEach((item, index) => {
        html += '<tr style="text-align: center">';
        html += `<td> ${index + 1} </td> <td>${item.ORDER_PRODUCT_NAME}</td>  <td>${item.ORDER_TYPE_UNIT}</td> <td>${item.ORDER_PRODUCT_CODE}</td>
                 <td>${item.DELIVER_PRICE}</td> <td>${item.DELIVER_COUNT}</td> <td>${((item.DELIVER_PRICE) * (item.DELIVER_COUNT)).toFixed(2)}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += `<div class="divTop" style="font-size:12px; right:1%; flex-direction: column; position:absolute; page-break-after: always; position: fixed; top: 250px; display:${this.isDisplay}">`;
      // html += '<div class="divTop" style="font-size:12px; display:flex; right:1%; flex-direction: column; position:absolute; page-break-after: always; position: fixed; top: 250px; display: isDisplay">';
      html += '<span style="font-size:15px">白</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">财</span>';
      html += '<span style="font-size:15px">务</span>';
      html += '<div style="height:5px;"> </div>';
      html += '<span style="font-size:15px">红</span>';
      html += '<span style="font-size:15px">联</span>';
      html += '<span style="font-size:15px">存</span>';
      html += '<span style="font-size:15px">根</span>';
      html += '<div style="height:5px;"></div>';
      html += '<span style="font-size:15px">黄</span>';
      html += '<span style="font-size:15px">联</span>';
      // html += '<span style="font-size:15px">领</span>';
      // html += '<span style="font-size:15px">料</span>';
      // html += '<span style="font-size:15px">/</span>';
      html += '<span style="font-size:15px">仓</span>';
      html += '<span style="font-size:15px">库</span>';
      // html += '<span style="font-size:15px">/</span>';
      // html += '<span style="font-size:15px">客</span>';
      // html += '<span style="font-size:15px">户</span>';
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += `<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 20px;"><div>出库时间：</div><div style="margin-left: 260px; font-size: 20px;">出库单总金额：${this.ALL_FEE}</div></div>`;
      html += `<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 20px;"><div  style="font-size: 20px;">主管：</div><div style="font-size: 20px;margin-left: 120px;">会计：</div><div style="font-size: 20px;margin-left: 120px;">验收：</div><div style="font-size: 20px;margin-left: 120px;">制单人：${this.managername}</div></div>`;
      html += '</div>';
      const windows = print(html);
      const params = {
        DELIVER_ID: Number(sessionStorage.getItem('DELIVER_ID')),
      };
      historyPrintTime(params)
        .then((result) => {
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      windows.close();
    },
    closeTurnoverInfoDialog() {
      this.turnoverInfoVisible = false;
      this.turnoverInfoForm.turnoverInfos = [{}];
    },
    submitTurnoverInfo() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 23,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: this.titleData[0].PROJECT_ID,
        BASKET_LIST: this.turnoverInfoForm.turnoverInfos,
        TYPE: 1,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '记录添加成功', type: 'success' });
        this.closeTurnoverInfoDialog();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 拉取周转筐数据
    queryTurnover() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result) {
          this.turnoverList = result;
        } else {
          this.turnoverList = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    openTurnoverInfoDialog() {
      this.queryTurnover();
      this.turnoverInfoVisible = true;
    },
    turnoverChange(item1) {
      const temp = this.turnoverList.find((item2) => item1.ID == item2.BASKET_ID);
      temp.disabled = !temp.disabled;
    },
  },
};
</script>
<style scoped>
  .footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
  }

  ul {
    list-style: none;
    min-height: 75px;
    padding: 0;
  }

  li {
    margin-bottom: 0;
    line-height: 25px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tableManage/historyDetail.vue